const { random, transform, sample } = require('lodash-es');
const armors = require('../_data/armors.json');

/**
 * Roll 1 dice for each armor type, if it's the maximum, there is something to
 * sell
 * 1d4 for light armor
 * 1d6 for medium
 * 1d8 for heavy
 * 1d10 for shield
 *
 * Then roll 1d20 for the type of enchantment
 * 1-13: Common, minor, +100po
 * 14-19: Uncommon, medium, +500po
 * 20: Rare, major, +5000po
 **/

module.exports = {
  availableTypes() {
    const types = [];
    if (random(1, 4) === 4) {
      types.push('light');
    }
    if (random(1, 6) === 6) {
      types.push('medium');
    }
    if (random(1, 8) === 8) {
      types.push('heavy');
    }
    if (random(1, 10) === 10) {
      types.push('shield');
    }
    return types;
  },
  enchantmentLevel() {
    const roll = random(1, 20);
    if (roll === 20) {
      return { name: 'rare', value: 5000 };
    }
    if (roll >= 14 && roll <= 19) {
      return { name: 'uncommon', value: 500 };
    }
    return { name: 'common', value: 100 };
  },
  run() {
    const availableTypes = this.availableTypes();
    return transform(
      availableTypes,
      (result, type) => {
        const randomArmor = sample(armors[type]);
        const magic = this.enchantmentLevel();
        const finalPrice = randomArmor.price + magic.value;
        result.push(
          `${randomArmor.name} magique (${magic.name}, ${finalPrice} po)`
        );
      },
      []
    );
  },
};
